<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="styleLoaded"/>
    </transition>
  </div>
</template>

<script>
import { agent } from '@/utils';

export default {
  data() {
    return {
      styleLoaded: false,
      lotteryActivity: {
        qa: {
          19: {
            style: 'lottery1',
            title: 'MG欢乐谷 玩淘趣 赢大奖',
          },
          20: {
            style: 'lottery2',
            title: '上汽MG东岸迷笛派×领航发布',
          },
        },
        prod: {
          8: {
            style: 'lottery1',
            title: 'MG欢乐谷 玩淘趣 赢大奖',
          },
          9: {
            style: 'lottery2',
            title: '上汽MG东岸迷笛派×领航发布',
          },
        },
      },
    };
  },
  created() {
    // 活动id判断
    const lotteryId = this.$route.query.lotteryId;
    if (!lotteryId) {
      this.$toast('活动id为空');
    } else {
      this.$store.commit('setLotteryId', lotteryId);
    }
    // 活动token判断
    const token = this.$route.query.token;
    if (!token) {
      if (agent === 'mp') {
        this.$toast('请登录');
        wx.miniProgram.redirectTo({
          url: `/pages/auth/auth?type=to&pageType=login&loginType=1&url=${encodeURIComponent(window.location.href)}`,
        });
        return;
      }
    }
    // 引用样式
    import('./assets/styles/lottery5.styl').then(() => {
      this.styleLoaded = true;
    });
  },
  mounted() {
    this.$store.dispatch('hideMask');
  },
};
</script>
